import { Drawer, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle } from '@/design-system/drawer/drawer';
import { ComponentProps } from 'react';
import { ReturnsDrawerContent } from './returns-drawer-content';

type ReturnsDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
} & ComponentProps<typeof ReturnsDrawerContent>;

export const ReturnsDrawer = (props: ReturnsDrawerProps) => {
  const { isOpen, onClose, ...cardProps } = props;

  return (
    <Drawer open={isOpen} onOpenChange={onClose} direction="right" modal={true}>
      <DrawerContent aria-describedby={undefined} className="data-[vaul-drawer-direction=right]:px-6">
        <DrawerHeader>
          <DrawerClose />

          <DrawerTitle>Returns</DrawerTitle>
        </DrawerHeader>

        <ReturnsDrawerContent {...cardProps} />
      </DrawerContent>
    </Drawer>
  );
};
